import {
  IGenerateStrategyProps,
  IStrategy,
  Leg,
  ViewType,
} from "../../../types";
import { analyzePositions } from "../../analyzeProfits";

export const generateLongStrangle = (
  params: IGenerateStrategyProps,
  strategies: IStrategy[],
  atmCallIndex: number,
  atmPutIndex: number,
  expiryDuration: number
): IStrategy[] => {
  const { maxStrikes, lotSize } = params;
  for (let i = 1; i < maxStrikes; i++) {
    const callStrike = params.data.strikePrices[atmCallIndex + i];
    const putStrike = params.data.strikePrices[atmPutIndex - i];

    const callData = params.data.data.find(
      (val) =>
        val.expiryDates === params.expiryDate && val.strikePrice === callStrike
    );
    const putData = params.data.data.find(
      (val) =>
        val.expiryDates === params.expiryDate && val.strikePrice === putStrike
    );

    const legs: Leg[] = [
      {
        strikePrice: callStrike,
        price: callData?.CE?.lastPrice || 0,
        buy: true,
        call: true,
        quantity: lotSize,
      },
      {
        strikePrice: putStrike,
        price: putData?.PE?.lastPrice || 0,
        buy: true,
        call: false,
        quantity: lotSize,
      },
    ];

    const analysis = analyzePositions(legs);
    const marginRequired = (legs[0].price + legs[1].price) * lotSize;
    const strategy: IStrategy = {
      legs: legs,
      riskRewardRatio: 1,
      maxProfit: Infinity,
      maxLoss: analysis.maxLoss,
      approxMargin: marginRequired,
      expiryDuration: expiryDuration,
      title: "Long Strangle " + callStrike + " - " + putStrike,
      maxLossROI: (analysis.maxLoss * 100) / marginRequired,
      maxProfitROI: Infinity,
      callBreakEven: analysis.breakEven.callBreakEven,
      putBreakEven: analysis.breakEven.putBreakEven,
      callBreakEvenPercentage:
        ((analysis.breakEven.callBreakEven - params.data.underlyingValue) /
          params.data.underlyingValue) *
        100,
      putBreakEvenPercentage:
        ((analysis.breakEven.putBreakEven - params.data.underlyingValue) /
          params.data.underlyingValue) *
        100,
      lotSize: params.lotSize,
      alert:
        "Long Strangle is a risky strategy. Very high chance for premium erosion if market does not move.",
        types: [
          ViewType["Extremely Positive"],
          ViewType["Extremely Negative"]
        ],
    };
    strategies.push(strategy);
  }
  return strategies;
};
